import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';

import SliderSlick from '../../../SliderSlick';

import { getLanguage } from '..';

import hermeticaLogo from '../../../../images/hermetica-logo.png'

export const MiniMediaSlider = () => {
    const content = {
        title: {
            en: `Specialty Coffee <br/> starts with you`,
            sp: `El café de especialidad <br/> comienza CONTIGO`,
            pt: `O café especial <br/> começa com VOCÊ`
        },
        description: {
            en: `<p>The voyage of Specialty Coffee begins with farmers that dedicate themselves to our industry. We are thankful for the positivity, work ethic and science you commit to the craft of working the land to help give us the coffee we enjoy.</p><p>Your passion for coffee is the inspiration to our HERMÉTICA brand of bulk green coffee packaging. With HERMÉTICA™, we work with you side by side in helping you protect and bring green coffee to the roasters we both serve.</p>`,
            sp: `<p>El viaje del café de especialidad comienza con los agricultores que se dedican a nuestra industria. Estamos agradecidos por su compromiso con el oficio de trabajar la tierra; por el positivismo, ética de trabajo y ciencia que ayuda a darnos el café que tanto disfrutamos.</p><p>Su pasión por el café es la inspiración para nuestra marca de empaques de café verde a granel HERMÉTICA ™. Con HERMÉTICA ™, trabajamos mano a mano junto a ustedes para ayudarlos a proteger y llevar café verde a los tostadores a quienes servimos.</p>`,
            pt: `<p>A viagem do Café Especial começa com agricultores que se dedicam à nossa indústria. Somos gratos pela positividade, ética de trabalho e ciência que você se compromete com o ofício de trabalhar a terra para ajudar a nos dar o café que desfrutamos. </p><p>Sua paixão pelo café é a inspiração para a nossa marca HERMÉTICA ™ da embalagens de café verde a granel. Com a HERMÉTICA ™, trabalhamos lado a lado para ajudá-lo a proteger e levar café verde às torrefadoras que servimos. </p>`
        }
    };

    const listsOfMedia = [
        'https://images.ctfassets.net/vhts96p7twn6/1ifTElcbG7PNt3wHylO7fL/3cd0bc15cd5817e822e7ec2be1303890/hermetica-gallery-1.png',
        'https://images.ctfassets.net/vhts96p7twn6/6fBFJFlmFzDrNo85tJuFoC/aa26e73eab304dbf3448383c69121ef2/hermetica-gallery-2.png',
        'https://images.ctfassets.net/vhts96p7twn6/1U3fIc24k7WmM91rNTVjh1/8d035caf16a0fc9eb2966b36fcc4c7b9/hermetica-gallery-3.png'
    ];

    const language = getLanguage();

    // Set up ref and inView hook for animation trigger
    const ref = useRef(null);
    const isInView = useInView(ref, { once: true, margin: '-100px 0px' });

    // Animation variants
    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: { staggerChildren: 0.3, delayChildren: 0.2 }
        }
    };

    const itemVariants = {
        hidden: { opacity: 0, y: 30 },
        visible: { opacity: 1, y: 0, transition: { duration: 0.5 } }
    };

    return (
        <div id='hermetica' ref={ref} className='relative '>
            <motion.div 
                className='relative block py-50 px-32 bg-light-sliver-gray border-lime-green left'
                initial="hidden"
                animate={isInView ? "visible" : "hidden"}
                variants={containerVariants}
            >
                <div className='grid col-2 col-1-lg col-1-md col-1-sm gap-30'>
                    <div className='relative z-2 block'>
                        <motion.h1 
                            className='text-3xl' 
                            dangerouslySetInnerHTML={{ __html: content.title[language] }} 
                            variants={itemVariants}
                        />
                        <motion.div 
                            dangerouslySetInnerHTML={{ __html: content.description[language] }} 
                            variants={itemVariants}
                        />
                        <motion.img 
                            src='https://images.ctfassets.net/vhts96p7twn6/1HdLlM1LexReJiV62SqaGF/2b9bf72a02ba7e5c870e0fa85017f4b5/hermetica.png' 
                            alt='Hermetica Packaging' 
                            variants={itemVariants}
                        />
                    </div>
                    <motion.div className='block' variants={itemVariants}>
                        <SliderSlick gallery={listsOfMedia}/>
                    </motion.div>
                </div>
                
            </motion.div>
            <div style={{ opacity: isInView ? 1 : 0, transition: "all .9s ease-in"}} className={`text-right component__textimage--slider__logo`}><img src={hermeticaLogo} alt="Hermetica Logo" /></div>
        </div>
    );
};